import { useQuery, useMutation, } from "@tanstack/react-query";
export const createUserQueries = (requests, queryClient) => ({
    // Keyed under "current-user" so it no longer collides with useFindUser and so
    // the invalidations in auth queries (which already target "current-user")
    // actually hit it.
    useCurrentUser: (params, options = {}) => useQuery({
        queryKey: ["current-user", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.getCurrentUser(params);
        },
        ...options,
    }),
    useListUsers: (params, options = {}) => useQuery({
        queryKey: ["users", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listUsers(params);
        },
        ...options,
    }),
    useFindUser: (params, options = {}) => useQuery({
        queryKey: ["user", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findUser(params);
        },
        ...options,
    }),
    useCreateUser: (options = {}) => useMutation({
        ...options,
        mutationFn: (userAttrs) => {
            return requests.createUser(userAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["users"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useUpdateUser: (options = {}) => useMutation({
        ...options,
        mutationFn: (userAttrs) => {
            return requests.updateUser(userAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["users"] });
            queryClient.invalidateQueries({ queryKey: ["user"] });
            queryClient.invalidateQueries({ queryKey: ["current-user"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useImpersonateUser: (options = {}) => useMutation({
        ...options,
        mutationFn: (userAttrs) => {
            return requests.impersonateUser(userAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.setQueryData(["current-user"], null);
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map